import * as React from 'react';

import { useGlobalState } from '../../contexts/state/GlobalStateContext';
import { Pane } from '../../ui/Pane';
import { useSpeciesContext } from './ISpeciesContext';
import { ISpecies } from '../../api/models/ISpecies';
import { SpeciesForm } from './SpeciesForm';

const SpeciesCreate = () => {
  const ctx = useSpeciesContext();
  const globalState = useGlobalState();
  const species = React.useRef<ISpecies>({} as ISpecies);
  const [valid, setValid] = React.useState(false);
  const [saving, setSaving] = React.useState(false);
  const [dirty, setDirty] = React.useState(false);

  const handleChange = (value: ISpecies, forceupdate: boolean) => {
    Object.assign(species.current, value);
  }  

  const handleValidate = (_valid: boolean) => {
    setValid(_valid);
  }  

  const handleSave = async () => {
    setDirty(true);
    if(!valid) return;
    setSaving(true);
    const result = await globalState.createSpecies(species.current)
    setSaving(false);
    if(result) ctx.setMode('list');
  }

  return (
    <>
      <Pane.Heading>
        <Pane.Title>AQUARISK</Pane.Title>
      </Pane.Heading>      
      <Pane.Subheader expandable>ADD SPECIES</Pane.Subheader>
            
      <Pane.Body>
        <SpeciesForm species={species.current} dirty={dirty} onChange={handleChange} onValidate={handleValidate}/>
      </Pane.Body>

      <Pane.Footer>
        <Pane.CancelButton onClick={() => ctx.setMode('list')}/>
        <Pane.SubmitButton disabled={saving} working={saving} onClick={handleSave}/>
      </Pane.Footer>
    </>
  )
}

export { SpeciesCreate }
